import { toast } from 'react-toastify';
import API from '../apiClient';


export const GetFrameworkIndustryTypes = () => {
  return new Promise((resolve, reject) => {
    API.get('/framework/industry-types')
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const GetFrameworkData = (options) => {
    const params = new URLSearchParams();
    if (options && typeof options === 'object' && options.includeControls === false) {
      params.set('include_controls', 'false');
    }
    const query = params.toString();
    return new Promise((resolve, reject) => {
      API.get(`/framework${query ? `?${query}` : ''}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          toast.error(error)
          console.log(error)
          reject(error)
        }); 
    });
  };

  export const GetFrameworkDataById = (entity) => {
    return new Promise((resolve, reject) => {
      API.get(`/framework/${encodeURIComponent(entity)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          toast.error(error)
          console.log(error)
          reject(error)
        }); 
    });
  };

  export const addFramework = (payload) => {
    return new Promise((resolve, reject) => {
        API.post(`/framework`, payload)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            toast.error(error)
            console.log(error)
            reject(error)
          });
    })

}

  export const UpdateFramework = (entity,payload) => {
    return new Promise((resolve, reject) => {
      API.put(`/framework/${encodeURIComponent(entity)}`,payload)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          toast.error(error)
          console.log(error)
          reject(error)
        }); 
    });
  };

  export const DeleteFramework = (entity) => {
    return new Promise((resolve,reject) => {
        API.post(`/framework/${encodeURIComponent(entity)}`)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            reject(error)
            toast.error(error)
            console.log(error)
          });
    })

}

// Returns the N×N framework comparison matrix.
// organizationId is optional — omit or pass null/'' for the universal mapping layer only.
// With organizationId, cells include implemented_mapped, implementation_percentage, effective_percentage.
export const GetFrameworkComparisonMatrix = (organizationId) => {
  const url = organizationId
    ? `/framework/comparison-matrix?organization_id=${encodeURIComponent(organizationId)}`
    : '/framework/comparison-matrix';
  return new Promise((resolve, reject) => {
    API.get(url)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
        console.error('Failed to get framework comparison matrix:', error);
      });
  });
};



